import { z } from 'zod';
export const emailSyntaxSchema = z.string().email({ message: 'invalid-email' });
export function isValidEmailSyntax(email) {
    return emailSyntaxSchema.safeParse(email ?? '').success;
}
